<template>
  <div v-if="shouldRender" class="container">
    <div class="container-header" data-testid="action-needed-submission">
      <div class="header">
        <div class="submission-line">
          <Typography variant="subtitle-1">Submission {{ submission.formSubmissionId }}</Typography>
          <ItemsChip :numberOfItems="claims.length" />
        </div>
        <Typography variant="body-2">
          <!-- Max 3 -->
          Claim ID:
          {{
            claims
              .slice(0, 3)
              .map((claim) => claim.formSubmissionEntryId)
              .join(", ")
          }}
        </Typography>
      </div>
      <Button iconLeft="mdi-pencil" @click="openModal"> Review</Button>
    </div>
    <Alert v-if="claims[0].reviewerComment" :message="alertMessage" />
    <div class="claim-info">
      <ClaimDates :claim="claims[0]" />
      <ClaimCustomer :claim="claims[0]" />
    </div>
    <ReviewSubmissionModal
      :value="modalVisible"
      @input="modalVisible = $event"
      :formSubmissionId="submission.formSubmissionId"
      :needsActionClaims="claims"
      :formAttachments="submission.FormAttachments"
      @claim-updated="$emit('claim-updated')"
    />
  </div>
</template>
<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import Alert from "@/components/generic/Alert.vue";
import ReviewSubmissionModal from "./ReviewSubmissionModal.vue";
import ItemsChip from "./ItemsChip.vue";
import ClaimDates from "./claims/claim-info/ClaimDates.vue";
import ClaimCustomer from "./claims/claim-info/ClaimCustomer.vue";
export default {
  components: {
    Typography,
    Button,
    Alert,
    ReviewSubmissionModal,
    ItemsChip,
    ClaimDates,
    ClaimCustomer,
  },
  computed: {
    shouldRender() {
      if (
        !this.submission.formSubmissionId ||
        !this.submission.ProgramClaimsViews ||
        this.submission.ProgramClaimsViews.length === 0
      ) {
        console.warn("submission Id or claims are not provided");
        return false;
      }
      return true;
    },
    alertMessage() {
      const firstComment = this.firstClaim && this.firstClaim.reviewerComment;
      return `Audit Note: ${firstComment || ""}`;
    },

    firstClaim() {
      return this.submission.ProgramClaimsViews[0];
    },
    claims() {
      return this.submission.ProgramClaimsViews;
    },
  },
  methods: {
    openModal() {
      this.modalVisible = true;
    },
  },

  data() {
    return {
      modalVisible: false,
    };
  },

  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  name: "NeedsActionClaim",
};
</script>

<style scoped>
.container {
  display: flex;
  border: 2px solid var(--v-warning-base);
  border-radius: 0.25rem;
  padding: 1rem;
}
.submission-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}
.header {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.container-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.claim-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
